import _ from "lodash";
import React from "react";
import LeadContact from "../LeadContact";
import FailedQueryIcon from "./icons/failed-query.png";

import { IconButton, Button, Grid } from "@mui/material"
import { ChevronLeft } from "@mui/icons-material"

import {
  data_create_api_resource,
  // dispatchNewRoute
} from "../../utils/http_functions";
import { i18n, dayjs } from "../../config";
import Settings from "../../settings";

const sortByName = (a, b) => {
  const nameA = a.name.toUpperCase();
  const nameB = b.name.toUpperCase();
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }

  // names must be equal
  return 0;
};

class Result extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      contactSent: false,
      errors: {},
    };

    let daysInYear = 0;
    for (var i = 0; i < 12; i++) {
      daysInYear += dayjs().month(i).daysInMonth();
    }
    this.daysInYear = daysInYear;
  }

  setStateAsync(state) {
    return new Promise((resolve) => {
      this.setState(state, resolve);
    });
  }

  handleSubmit = (data) => {
    data_create_api_resource(null, "gas/price-compare", {
      cups: this.props.cups,
      ...data,
    }, 2);
    this.setState({ contactSent: true });
  };

  handleSeeOurProducts = () => {
    if (i18n.exists('common:url.ourGasProducts')){
      // dispatchNewRoute(i18n.t('common:url.ourGasProducts'));
    }
  };

  handleContractNow = () => {
    if (i18n.exists('common:url.gasContractation')){
      // dispatchNewRoute(i18n.t('common:url.gasContractation'));
    }
  };

  handleContractDualNow = () => {
    if (i18n.exists('common:url.dualContractation')){
      // dispatchNewRoute(i18n.t('common:url.dualContractation'));
    }
  };

  getTaxes = (taxes) => {
    let taxList = [];
    if (taxes.length) {
      taxList = taxes.map((tax) => {
        let name = tax.name;
        let specialTax = name.indexOf("Impuesto especial") !== -1;
        return (
          <div className={specialTax ? "special-tax" : "tax"} key={tax.name}>
            {name}
            <span className="amount">
              {Number(tax.amount).toFixed(2)} €
            </span>
          </div>
          );
        }
      );
    }
    return taxList;
  };

  renderDetails = (result) => {
    let total = result.total_amount,
      totalFijo = 0,
      totalVariable = 0;

    if (result && result.operations) {
      const operations = result.operations;
      if (operations.lines) {
        if (operations.lines.fijo && operations.lines.fijo.length) {
          totalFijo = operations.lines.fijo.reduce(
            (t, { price_unit, quantity, multi }) =>
              t + price_unit * quantity * multi,
            0
          );
        }
        if (operations.lines.variable && operations.lines.variable.length) {
          totalVariable = operations.lines.variable.reduce(
            (t, { price_unit, quantity, multi }) =>
              t + price_unit * quantity * multi,
            0
          );
        }
      }
    }

    const savingDetailTitle = _.template(i18n.t('common:text.price_comparator_saving_detail_title'));
    const taxes = this.getTaxes(result.operations.taxes);

    return (
      <div className="saving-detail">
        <div className="saving-detail-note">
          {i18n.t('common:text.price_comparator_saving_detail_note')}
        </div>
        <h2 className="saving-detail-title">
          {savingDetailTitle({
            companyName: _.get(Settings, 'organization.name')
          })}
        </h2>

        <h3 className="energy-sum">
          {i18n.t('common:text.gas_price_comparator_detail_summary_fijo')}
          <Grid container justifyContent="flex-end">
            {Number(totalFijo).toFixed(2)} €
          </Grid>
        </h3>
        {result.operations.lines.fijo
          .sort(sortByName)
          .map((line, index) => {
            return (
              <div key={index}>
                {line.name} — {line.quantity} kWh × {line.price_unit} €/kWh{" "}
                <Grid container justifyContent="flex-end">
                  {Number(line.quantity * line.price_unit).toFixed(2)} €
                </Grid>
              </div>
            );
          })}
        
        <h3 className="other-sum">
          {i18n.t('common:text.gas_price_comparator_detail_summary_variable')}
          <Grid container justifyContent="flex-end">
            {Number(totalVariable).toFixed(2)} €
          </Grid>
        </h3>

        {result.operations.lines.variable
          .sort(sortByName)
          .map((line, index) => {
            return (
              <div key={index}>
                {line.name} — {line.quantity} kWh × {line.price_unit} €/kWh{" "}
                <Grid container justifyContent="flex-end">
                  {Number(line.quantity * line.price_unit).toFixed(2)} €
                </Grid>
              </div>
            );
          })}

        {taxes}

        <div className="total">
          Total {Number(total).toFixed(2)} €
        </div>
      </div>
    );
  }

  renderSavingResult = (result) => {
    return (
      <div className="result">
        {this.renderHeader(result.header)}
        <div>
          <div>
            {result.operations && this.renderDetails(result)}
          </div>
          <div>
            {this.renderContent(result.content)}
          </div>
        </div>
        <div>
          <div>
            <div className="contact-container">
              <h2>{i18n.t('common:text.price_comparator_i_am_interested')}</h2>
              <LeadContact onSubmit={this.handleSubmit} />
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderHeader = (header) => {
    return <div dangerouslySetInnerHTML={{ __html: header }} />;
  };

  renderContent = (content) => {
    let renderResult = null;
    if (content) {
      const buttons = (
        <div className="contract-now">
          <div className="see-our-products-btn">
            <Button
              className="secondary-btn"
              variant={'contained'}
              fullWidth={true}
              buttonStyle={{ height: "52px" }}
              labelStyle={{ fontSize: "31px", fontWeight: "600" }}
              onClick={this.handleSeeOurProducts}
            >
              {i18n.t('common:text.price_comparator_our_products')}
            </Button>
          </div>
          <div className="contract-now-btn">
            <Button
              variant={'contained'}
              className="secondary-btn"
              fullWidth={true}
              buttonStyle={{ height: "52px" }}
              labelStyle={{ fontSize: "31px", fontWeight: "600" }}
              onClick={this.handleContractNow}
            >
              {i18n.t('common:text.price_comparator_contract_now')}
            </Button>
          </div>
          <br />
          <p>{i18n.t('common:text.price_comparator_dual_contractation')}</p>
          <div className="contract-now-btn">
            <Button
              variant={'contained'}
              className="secondary-btn"
              fullWidth={true}
              buttonStyle={{ height: "52px" }}
              labelStyle={{ fontSize: "31px", fontWeight: "600" }}
              onClick={this.handleContractDualNow}
            >
              {i18n.t('common:text.price_comparator_contract_now_dual')}
            </Button>
          </div>
        </div>
      );
      renderResult = (
        <div>
          <div 
            className="summary"
            onClick={this.handleSeeOurProducts}
            dangerouslySetInnerHTML={{ __html: content }}
          />
          {buttons}
        </div>
      );
    }

    return renderResult;
  };

  renderContact = () => {
    return (
      <div className="contact-container">
        <img src={FailedQueryIcon} alt=""/>
        <h1>{i18n.t('common:text.price_comparator_contact_title')}</h1>
        <h2>{i18n.t('common:text.price_comparator_contact_subtitle')}</h2>
        <LeadContact onSubmit={this.handleSubmit} attachInvoice={true} />
      </div>
    );
  };

  render() {
    const { props } = this;
    const { contactSent } = this.state;

    return (
      <div>
        <IconButton onClick={this.props.onGoBack} className="btn-back">
          <ChevronLeft className="btn-back-icon" />
        </IconButton>
        {contactSent ? (
          <h3>{i18n.t('common:text.price_comparator_contact_sent')}</h3>
        ) : (
          props.saving &&
            this.renderSavingResult(props.saving)
        )}
      </div>
    );
  }
}

export default Result;
